/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLetterTime: {
  name: 'letter-time';
  data: string;
} = {
  name: 'letter-time',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 6.948V5h12v1.948h-4.838V20H10.83V6.948H6Z" fill="currentColor"/></svg>`,
};
